var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-query-builder',{staticClass:"react-query-builder",attrs:{"labels":_vm.labels,"rules":_vm.rules,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }